"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _OriginDestinationSR_SMmap = _interopRequireDefault(require("../widgets/OriginDestinationSR_SMmap.mapWidget"));
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class OctaviMaps extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEnabled: _ServiceLocator.default.collectionManager.has('zones'),
      taxiDataSourceId: null,
      startAt: null,
      endAt: null,
      zoneDataHasLoaded: false,
      mapOptions: _OctaviParameters.default.mapOptions
    };

    //sonce we don't have filter comparison in map, we make shure to have filterOne selected
    _OctaviParameters.default.filterSelected = "FilterOne";
    _ServiceLocator.default.eventManager.emit('taxi.filter.filterSelection.update');
    this.enableMap = this.enableMap.bind(this);
    this.updateDataSourceIds = this.updateDataSourceIds.bind(this);
    this.updateWidgetSelection = this.updateWidgetSelection.bind(this);
    this.loadZones_lvl1 = this.loadZones_lvl1.bind(this);
    this.addFeaturesDataProp = this.addFeaturesDataProp.bind(this);

    //init zone data
    this.state = _objectSpread(_objectSpread({}, this.state), {}, {
      zone_data: this.loadZones_lvl1()
    });
    this.state = _objectSpread(_objectSpread({}, this.state), {}, {
      zoneDataHasLoaded: true
    });
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on('taxi.dataSources.loaded', this.updateDataSourceIds);
    _ServiceLocator.default.eventManager.on('taxi.filter.selectedMapOptions.update', this.updateWidgetSelection);
    _ServiceLocator.default.eventManager.on("taxi.filter.spatial.enable", this.enableMap);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off('taxi.dataSources.loaded', this.updateDataSourceIds);
    _ServiceLocator.default.eventManager.off('taxi.filter.selectedMapOptions.update', this.updateWidgetSelection);
    _ServiceLocator.default.eventManager.off("taxi.filter.spatial.enable", this.enableMap);
  }
  enableMap() {
    this.setState({
      isEnabled: true,
      zone_data: this.loadZones_lvl1()
    });
  }
  updateDataSourceIds() {
    this.setState({
      dataSourceIds: _OctaviParameters.default.dataSourceIds
    });
  }
  updateWidgetSelection() {
    let newSelectedMapWidget = _OctaviParameters.default.selectedMapWidget;
    this.setState({
      selectedMapWidget: newSelectedMapWidget
    });
  }
  loadZones_lvl1() {
    let features = _ServiceLocator.default.collectionManager.has('zones') ? _ServiceLocator.default.collectionManager.get('zones').features : [];
    features = this.addFeaturesDataProp('SM', features);
    features = this.addFeaturesDataProp('SR', features);
    features = this.addFeaturesDataProp('SM_name', features);
    return {
      features: features,
      type: "FeatureCollection"
    };
  }
  addFeaturesDataProp(propName, features) {
    return features.map(function (item) {
      const newProps = _objectSpread({}, item.properties);
      newProps[propName] = item.properties.data[propName];
      return _objectSpread(_objectSpread({}, item), {}, {
        properties: newProps
      });
    });
  }
  getSelectedWidgetComponent() {
    if (this.state.mapOptions.selectedMapStyle && this.state.mapOptions.selectedMapStyle == "SRMap" || this.state.mapOptions.selectedMapStyle == "SMMap") {
      return /*#__PURE__*/_react.default.createElement(_OriginDestinationSR_SMmap.default, {
        key: "taxiOriginMapWidgetSMSR",
        t: this.props.t,
        i18n: this.props.i18n,
        zone_data: this.state.zone_data,
        isEnabled: this.state.isEnabled
      });
    }
  }
  render() {
    if (_OctaviParameters.default.dataSourceIds.length === 0) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
    }
    // if map by zones, we make sure that the zones had time to load
    if ((this.state.mapOptions.selectedMapStyle && this.state.mapOptions.selectedMapStyle == "SRMap" || this.state.mapOptions.selectedMapStyle == "SMMap") && (!this.state.zoneDataHasLoaded || !this.state.isEnabled)) {
      return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        height: '100%'
      }
    }, this.getSelectedWidgetComponent());
  }
}
exports.default = OctaviMaps;